// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base Variables */
:root {
    --chatbot-primary-color: #5c6bc0;
    --chatbot-primary-light: #8e99f3;
    --chatbot-primary-dark: #26418f;
    --chatbot-text-color: #333333;
    --chatbot-text-light: #ffffff;
    --chatbot-bg-color: #ffffff;
    --chatbot-bot-msg-bg: #f0f2ff;
    --chatbot-user-msg-bg: #e3f2fd;
    --chatbot-border-radius: 12px;
    --chatbot-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
    --chatbot-transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    --chatbot-font: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

/* Reset */
.chatbot-widget *,
.chatbot-widget *::before,
.chatbot-widget *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

/* Main Container */
.chatbot-widget {
    position: fixed;
    bottom: 20px;
    z-index: 9999;
    font-family: var(--chatbot-font);
    color: var(--chatbot-text-color);
    line-height: 1.5;
    font-size: 14px;
}

.chatbot-right {
  right: 20px;
}

.chatbot-left {
  left: 20px;
}

/* Toggle Button */
.chatbot-toggle-btn {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: var(--chatbot-primary-color);
    color: var(--chatbot-text-light);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: var(--chatbot-shadow);
    transition: var(--chatbot-transition);
    border: none;
    outline: none;
    position: relative;
    z-index: 1;
}

    .chatbot-toggle-btn:hover {
        background-color: var(--chatbot-primary-dark);
        transform: scale(1.05);
    }

    .chatbot-toggle-btn:active {
        transform: scale(0.95);
    }

    .chatbot-toggle-btn svg {
        width: 24px;
        height: 24px;
        transition: var(--chatbot-transition);
    }

/* Chat Window */
.chatbot-window {
    position: absolute;
    bottom: 80px;
    
    /* width: 350px;
    height: 500px; */
    width: 25rem;
    height: 35rem;
    background-color: var(--chatbot-bg-color);
    border-radius: var(--chatbot-border-radius);
    box-shadow: var(--chatbot-shadow);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    transition: var(--chatbot-transition);
    opacity: 0;
    transform: translateY(20px) scale(0.95);
    pointer-events: none;
    visibility: hidden;
}

.chatbot-window-left {
    left: 0;
}

.chatbot-window-right {
    right: 0;
}

    .chatbot-window.active {
        opacity: 1;
        transform: translateY(0) scale(1);
        pointer-events: all;
        visibility: visible;
    }

/* Header */
.chatbot-header {
    padding: 16px;
    background-color: var(--chatbot-primary-color);
    color: var(--chatbot-text-light);
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top-left-radius: var(--chatbot-border-radius);
    border-top-right-radius: var(--chatbot-border-radius);
}

.chatbot-title {
    font-weight: 600;
    font-size: 16px;
    text-align: center;
    flex-grow: 1;
}

.chatbot-options-btn {
    background: transparent;
    border: none;
    color: var(--chatbot-text-light);
    cursor: pointer;
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: var(--chatbot-transition);
    border-radius: 50%;
    display: none;
}

    .chatbot-options-btn:hover {
        background-color: rgba(255, 255, 255, 0.1);
    }

/* Messages Container */
.chatbot-messages {
    flex-grow: 1;
    padding: 16px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 12px;
    scroll-behavior: smooth;
    background-color: #f9fafc;
}

    .chatbot-messages::-webkit-scrollbar {
        width: 6px;
    }

    .chatbot-messages::-webkit-scrollbar-track {
        background: transparent;
    }

    .chatbot-messages::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.1);
        border-radius: 10px;
    }

/* Message Bubbles */
.chatbot-message {
    max-width: 80%;
    padding: 12px 16px;
    border-radius: 18px;
    word-wrap: break-word;
    position: relative;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

    .chatbot-message.bot {
        align-self: flex-start;
        background-color: var(--chatbot-bot-msg-bg);
        border-bottom-left-radius: 4px;
        color: var(--chatbot-text-color);
    }

    .chatbot-message.user {
        align-self: flex-end;
        background-color: var(--chatbot-primary-color);
        border-bottom-right-radius: 4px;
        color: var(--chatbot-text-light);
    }

.chatbot-message-time {
    font-size: 10px;
    opacity: 0.7;
    margin-top: 4px;
    text-align: right;
}

/* Typing Indicator */
.chatbot-typing {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    background-color: var(--chatbot-bot-msg-bg);
    border-radius: 18px;
    border-bottom-left-radius: 4px;
    max-width: 80px;
    align-self: flex-start;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.chatbot-typing-dot {
    width: 8px;
    height: 8px;
    background-color: var(--chatbot-primary-color);
    border-radius: 50%;
    margin-right: 4px;
    animation: typing-dot 1.4s infinite ease-in-out;
    opacity: 0.7;
}

    .chatbot-typing-dot:nth-child(1) {
        animation-delay: 0s;
    }

    .chatbot-typing-dot:nth-child(2) {
        animation-delay: 0.2s;
    }

    .chatbot-typing-dot:nth-child(3) {
        animation-delay: 0.4s;
        margin-right: 0;
    }

@keyframes typing-dot {
    0%, 60%, 100% {
        transform: translateY(0);
    }

    30% {
        transform: translateY(-5px);
    }
}

/* Input Area */
.chatbot-input-container {
    display: flex;
    padding: 12px 16px;
    border-top: 1px solid #eee;
    background-color: var(--chatbot-bg-color);
    align-items: center;
}

.chatbot-input {
    flex-grow: 1;
    border: 1px solid #ddd;
    border-radius: 24px;
    padding: 10px 16px;
    outline: none;
    font-family: var(--chatbot-font);
    font-size: 14px;
    resize: none;
    max-height: 100px;
    min-height: 40px;
    overflow-y: auto;
    transition: var(--chatbot-transition);
    
    /* Custom webkit scrollbar styling */
    scrollbar-width: none;
    -ms-overflow-style: none; 
    /* scrollbar-color: #ccc transparent; */
}

/* Webkit scrollbar styles */
.chatbot-input::-webkit-scrollbar {
    /* width: 6px; */
    display: none;
}

/* .chatbot-input::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 3px;
}

.chatbot-input::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 3px;
    transition: background-color 0.2s ease;
}

.chatbot-input::-webkit-scrollbar-thumb:hover {
    background-color: #999;
}

.chatbot-input::-webkit-scrollbar-corner {
    background: transparent;
}
*/
    .chatbot-input:focus {
        border-color: var(--chatbot-primary-color);
        box-shadow: 0 0 0 2px rgba(92, 107, 192, 0.2);
    }

.chatbot-send-btn {
    background-color: var(--chatbot-primary-color);
    border: none;
    color: var(--chatbot-text-light);
    cursor: pointer;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-left: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: var(--chatbot-transition);
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

    .chatbot-send-btn:hover {
        background-color: var(--chatbot-primary-dark);
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    }

    .chatbot-send-btn:active {
        transform: translateY(0);
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    }

    .chatbot-send-btn svg {
        width: 18px;
        height: 18px;
    }

    .chatbot-send-btn:disabled {
        background-color: #ccc;
        cursor: not-allowed;
        transform: none;
        box-shadow: none;
    }

/* Welcome Message */
.chatbot-welcome {
    text-align: center;
    padding: 16px;
    color: #666;
    font-style: italic;
}

/* Responsive Design */
@media (max-width: 480px) {
    .chatbot-window {
        width: calc(100vw - 40px);
        height: calc(100vh - 120px);
        bottom: 80px;
        right: 0;
    }

    .chatbot-toggle-btn {
        width: 50px;
        height: 50px;
    }

        .chatbot-toggle-btn svg {
            width: 20px;
            height: 20px;
        }
}

/* Animation for new messages */
@keyframes message-appear {
    from {
        opacity: 0;
        transform: translateY(10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.chatbot-message {
    animation: message-appear 0.3s ease-out;
}

.chatbot-message-content-user p {
    color: #fff !important;
}

/*footer*/

.chatbot-footer {
    padding: 8px 16px;
    background-color: #f8f9fa;
    border-top: 1px solid #e9ecef;
    text-align: center;
    font-size: 11px;
    color: #6c757d;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
}

.chatbot-powered-by {
    color: #6c757d;
}

.chatbot-powered-link {
    color: var(--chatbot-primary-color, #5c6bc0);
    text-decoration: none;
    font-weight: 500;
    transition: color 0.2s ease;
}

.chatbot-powered-link:hover {
    color: var(--chatbot-primary-color-dark, #3f51b5);
    text-decoration: underline;
}

.chatbot-powered-logo {
    height: 15px;
    width: auto;
    vertical-align: middle;
}


/* For Support desk */
/* Base Button Style with Transition */
.chatbot-buttons {
    /* display: flex;
     flex-wrap: wrap;
    gap: 8px;
    margin-top: 12px;
    margin-left: 5px;
    justify-content: flex-start; */
     display: flex;
    flex-wrap: wrap; /* Allow buttons to wrap on small screens */
    gap: 8px;
    margin-top: 12px;
    margin-left: 5px;
    justify-content: flex-start;
    width: 100%; /* Ensure full width */
}

.chatbot-button {
    /* display: inline-flex;
    align-items: center;
    justify-content: center;
    
    border-radius: 16px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease-out;
    border: none;
    outline: none;
    
      min-width: calc(50% - 10px);
    height: 35px;
    box-sizing: border-box; */

     display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 16px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease-out;
    border: none;
    outline: none;
    min-width: auto; /* Remove fixed min-width */
    /* padding: 6px 16px;  */
    height: 35px;
    box-sizing: border-box;
    flex: 1 1 auto; /* Allow buttons to grow and shrink */
    white-space: nowrap; /* Prevent text wrapping */
    max-width: 100%; /* Prevent overflow */
}

/* Primary Button Hover Effects */
.chatbot-button--primary {
    background-color: var(--chatbot-primary-color);
    color: white;
    box-shadow: 0 1px 2px rgba(74, 107, 255, 0.2);
}

.chatbot-button--primary:hover {
    background-color: var(--chatbot-primary-dark);
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(74, 107, 255, 0.3);
}

/* Secondary Button Hover Effects */
.chatbot-button--secondary {
    background-color: #f5f5f5;
    color: #333;
    border: 1px solid #ddd;
}

.chatbot-button--secondary:hover {
    background-color: #e9e9e9;
    border-color: #ccc;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Active State for Both Buttons */
.chatbot-button:active {
    transform: translateY(0);
    transition: all 0.1s ease;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

/* Options container */
.chatbot-options-container {
    display: flex;
    flex-direction: column;
    gap: 8px;
    /* Reduced from 10px */
    margin-top: 10px;
    /* Reduced from 12px */
    width: 100%;
}

/* Base button style */
.chatbot-option-button {
    width: 100%;
    padding: 8px 12px;
    /* Reduced from 12px 16px */
    border: none;
    border-radius: 6px;
    /* Slightly smaller radius */
    background-color: #f0f4f8;
    color: #2d3748;
    font-size: 13px;
    /* Reduced from 14px */
    font-weight: 500;
    text-align: center;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

/* Small button variant */
.chatbot-option-button-small {
    padding: 6px 10px;
    /* Even smaller padding */
    font-size: 12px;
    /* Smaller font */
    min-height: 32px;
    /* Fixed height */
}

.chatbot-option-button:hover {
    background-color: #e2e8f0;
    transform: translateY(-1px);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    /* Lighter shadow */
}

.chatbot-option-button:active {
    transform: translateY(0);
    box-shadow: none;
}


.chatbot-option-button:disabled,
.chatbot-option-button.disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.chatbot-attach-btn {
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 4px;
    color: #666;
    position: absolute;
    left: 26px;
}

.chatbot-attach-btn:hover {
    color: #000;
}




/* Support Form Styles - Clean Material Design */
 .support-form-container {
    /* max-width: 100% !important; */
    padding: 0 !important;
    background: #ffffff !important;
    border-radius: 16px !important;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08) !important;
    margin: 16px 0 !important;
  
    border: 1px solid #f0f0f0;
} 

.support-form-header {
    font-size: 15px;
    font-weight: 600;
    color: #1a1a1a;
    margin: 0;
    padding: 12px 12px 12px 12px;
    text-align: center;
    /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */
    background-color: var(--chatbot-primary-color);
    color: white;
    position: relative;
}

.support-form-header::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: rgba(255, 255, 255, 0.2);
}

.support-form {
    display: flex;
    flex-direction: column;
    gap: 0;
    padding: 24px;
}

.form-field {
    position: relative;
    margin-bottom: 10px;
}

.form-input-chatbot,
.form-select-chatbot,
.form-textarea-chatbot {
    width: 100%;
    padding: 5px 10px 10px 10px;
    border: 2px solid #e8eaed;
    border-radius: 12px;
    background-color: #ffffff;
    font-size: 16px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    color: #202124;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    outline: none;
    box-sizing: border-box;
    appearance: none;
}

.form-input-chatbot:focus,
.form-select-chatbot:focus,
.form-textarea-chatbot:focus {
    border-color: #4285f4;
    background-color: #ffffff;
    box-shadow: 0 0 0 4px rgba(66, 133, 244, 0.1);
    transform: translateY(-1px);
}

.form-input-chatbot:hover:not(:focus),
.form-select-chatbot:hover:not(:focus),
.form-textarea-chatbot:hover:not(:focus) {
    border-color: #dadce0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
} 


.form-label {
    position: absolute;
    left: 16px;
    top: 12px;
    font-size: 13px;
    color: #5f6368;
    pointer-events: none;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    transform-origin: left top;
    background: white;
    padding: 0 4px;
    margin-left: -4px;
    font-weight: 400;
}

.form-input-chatbot:focus + .form-label,
.form-input-chatbot:not(:placeholder-shown) + .form-label,
.form-select-chatbot:focus + .form-label,
.form-select-chatbot:valid + .form-label,
.form-textarea-chatbot:focus + .form-label,
.form-textarea-chatbot:not(:placeholder-shown) + .form-label {
    transform: translateY(-22px) scale(0.75);
    /* transform: translateY(-28px) scale(0.75); */
    color: #4285f4;
    font-weight: 500;
}


.form-underline {
    display: none;
}
.form-textarea {
    resize: vertical;
    min-height: 120px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    line-height: 1.5;
}
form-field-file {
    margin-bottom: 10px;
}

.form-file-input {
    display: none;
}

.form-file-label {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 7px;
    border: 2px dashed #dadce0;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    background-color: #fafbfc;
    position: relative;
    overflow: hidden;
}

.form-file-label::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(66, 133, 244, 0.1), transparent);
    transition: left 0.5s;
}

.form-file-label:hover {
    border-color: #4285f4;
    background-color: #f8f9ff;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(66, 133, 244, 0.15);
}

.form-file-label:hover::before {
    left: 100%;
}

.file-icon {
    font-size: 18px;
    color: #4285f4;
}

.file-text {
    color: #5f6368;
    font-size: 14px;
    font-weight: 500;
}


.form-actions {
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    margin-top: 0px;
    padding-top: 24px;
    border-top: 1px solid #f0f0f0;
} 


.btn-chatbot {
    position: relative;
    padding: 10px 32px;
    border: none;
    border-radius: 24px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    overflow: hidden;
    text-transform: none;
    letter-spacing: 0.25px;
    min-width: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.btn-chatbot-primary {
    background: linear-gradient(135deg, #4285f4 0%, #34a853 100%);
    color: white;
    box-shadow: 0 2px 8px rgba(66, 133, 244, 0.3);
}

.btn-chatbot-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(66, 133, 244, 0.4);
}

.btn-chatbot-primary:active {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(66, 133, 244, 0.3);
}

.btn-chatbot-secondary {
    background-color: #ffffff;
    color: #5f6368;
    border: 2px solid #e8eaed;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.btn-chatbot-secondary:hover {
    background-color: #f8f9fa;
    border-color: #dadce0;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.btn-chatbot-secondary:active {
    transform: translateY(0);
    background-color: #f1f3f4;
}


.btn-chatbot.loading {
    pointer-events: none;
    opacity: 0.8;
}

.btn-chatbot.loading .btn-chatbot-text::after {
    content: '';
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-left: 8px;
    border: 2px solid currentColor;
    border-radius: 50%;
    border-top-color: transparent;
    animation: spin 1s linear infinite;
}


.btn-chatbot-ripple {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.4);
    transform: translate(-50%, -50%);
    transition: width 0.6s ease, height 0.6s ease;
    pointer-events: none;
}

.btn-chatbot:active .btn-chatbot-ripple {
    width: 300px;
    height: 300px;
} 


/* Animations */
@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

/* Form Validation */
.form-input-chatbot:invalid:not(:placeholder-shown),
.form-select-chatbot:invalid,
.form-textarea-chatbot:invalid:not(:placeholder-shown) {
    border-color: #ea4335;
    background-color: #fef7f0;
}

.form-input-chatbot:invalid:not(:placeholder-shown):focus,
.form-select-chatbot:invalid:focus,
.form-textarea-chatbot:invalid:not(:placeholder-shown):focus {
    box-shadow: 0 0 0 4px rgba(234, 67, 53, 0.1);
}

.form-input-chatbot:invalid:not(:placeholder-shown)+.form-label,
.form-select:invalid+.form-label,
.form-textarea-chatbot:invalid:not(:placeholder-shown)+.form-label {
    color: #ea4335;
}

/* Success State */
.form-input-chatbot:valid:not(:placeholder-shown),
.form-select-chatbot:valid:not([value=""]),
.form-textarea-chatbot:valid:not(:placeholder-shown) {
    border-color: #34a853;
}

.form-input-chatbot:valid:not(:placeholder-shown)+.form-label,
.form-select-chatbot:valid:not([value=""])+.form-label,
.form-textarea-chatbot:valid:not(:placeholder-shown)+.form-label {
    color: #34a853;
}


/* Enhanced Quick Actions with Material Design */
.quick-actions-container {
    background: transparent !important;
    padding: 12px 0 !important;
    margin: 8px 0 !important;
}

.quick-actions {
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-width: 320px;
}

.quick-action-btn {
    padding: 16px 20px;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border: 2px solid #e8eaed;
    border-radius: 16px;
    color: #1a73e8;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    text-align: left;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    position: relative;
    overflow: hidden;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.quick-action-btn::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(26, 115, 232, 0.1), transparent);
    transition: left 0.5s;
}

.quick-action-btn:hover {
    background: linear-gradient(135deg, #f8f9ff 0%, #e8f0fe 100%);
    border-color: #4285f4;
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(66, 133, 244, 0.2);
}

.quick-action-btn:hover::before {
    left: 100%;
}

.quick-action-btn:active {
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(66, 133, 244, 0.15);
}

.quick-action-btn:focus {
    outline: none;
    border-color: #4285f4;
    box-shadow: 0 0 0 4px rgba(66, 133, 244, 0.1);
}

@media (max-width: 480px) {
    .quick-actions {
        max-width: 100%;
    }

    .quick-action-btn {
        text-align: center;
        padding: 18px 20px;
        font-size: 16px;
        min-height: 48px;
        touch-action: manipulation;
    }
}

@media (prefers-color-scheme: dark) {
    .quick-action-btn {
        background: linear-gradient(135deg, #2d2d2d 0%, #333 100%);
        border-color: #444;
        color: #8ab4f8;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    }

    .quick-action-btn:hover {
        background: linear-gradient(135deg, #333 0%, #3c3c3c 100%);
        border-color: #8ab4f8;
        box-shadow: 0 4px 16px rgba(138, 180, 248, 0.2);
    }

    .quick-action-btn::before {
        background: linear-gradient(90deg, transparent, rgba(138, 180, 248, 0.1), transparent);
    }
}

.file-list {
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.file-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    background-color: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #e8eaed;
    transition: all 0.2s ease;
}

.file-item:hover {
    background-color: #f1f3f4;
    border-color: #dadce0;
}

.file-name {
    flex: 1;
    color: #202124;
    font-weight: 500;
    margin-right: 12px;
    font-size: 14px;
    overflow-x: auto;
}

.file-size {
    color: #5f6368;
    font-size: 12px;
    margin-right: 12px;
    background: #e8f0fe;
    padding: 2px 8px;
    border-radius: 12px;
}

.file-remove {
    background: #fff;
    border: 1px solid #dadce0;
    color: #ea4335;
    font-size: 16px;
    cursor: pointer;
    padding: 0;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.2s ease;
    font-weight: bold;
}

.file-remove:hover {
    background-color: #fce8e6;
    border-color: #ea4335;
    transform: scale(1.1);
} 
/* for live chat */
.chatlive-send-btn {
     background-color: var(--chatbot-primary-color);
     border: none;
     color: var(--chatbot-text-light);
     cursor: pointer;
     width: 40px;
     height: 40px;
     border-radius: 50%;
     margin-left: 8px !important;
     display: none;
     align-items: center;
     justify-content: center;
     transition: var(--chatbot-transition);
     box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
 }
 
     .chatlive-send-btn:hover {
         background-color: var(--chatbot-primary-dark);
         transform: translateY(-2px);
         box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
     }
 
     .chatlive-send-btn:active {
         transform: translateY(0);
         box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
     }
 
     .chatlive-send-btn svg {
         width: 18px;
         height: 18px;
     }
 
 .active-op {
     background-color: #4a90e2 !important;
     color: white !important;
 }
 .inactive-op {
     background-color: #f5f5f5 !important;
     color: #333 !important;
 }



 /* For Type indecater dor live chat */
 .typing-indicator {
    font-style: italic;
    margin: 5px 0;
    color: #555;
}

.typing-indicator .dot {
    height: 6px;
    width: 6px;
    margin: 0 2px;
    background-color: #555;
    border-radius: 50%;
    display: inline-block;
    animation: blink 1s infinite;
}

.typing-indicator .dot:nth-child(2) { animation-delay: 0.2s; }
.typing-indicator .dot:nth-child(3) { animation-delay: 0.4s; }

@keyframes blink {
    0%, 80%, 100% { opacity: 0; }
    40% { opacity: 1; }
}
`, "",{"version":3,"sources":["webpack://./src/css/chatbot.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,gCAAgC;IAChC,gCAAgC;IAChC,+BAA+B;IAC/B,6BAA6B;IAC7B,6BAA6B;IAC7B,2BAA2B;IAC3B,6BAA6B;IAC7B,8BAA8B;IAC9B,6BAA6B;IAC7B,gDAAgD;IAChD,+DAA+D;IAC/D,2IAA2I;AAC/I;;AAEA,UAAU;AACV;;;IAGI,sBAAsB;IACtB,SAAS;IACT,UAAU;AACd;;AAEA,mBAAmB;AACnB;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,gCAAgC;IAChC,gCAAgC;IAChC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA,kBAAkB;AAClB;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,8CAA8C;IAC9C,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,iCAAiC;IACjC,qCAAqC;IACrC,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,UAAU;AACd;;IAEI;QACI,6CAA6C;QAC7C,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,qCAAqC;IACzC;;AAEJ,gBAAgB;AAChB;IACI,kBAAkB;IAClB,YAAY;;IAEZ;oBACgB;IAChB,YAAY;IACZ,aAAa;IACb,yCAAyC;IACzC,2CAA2C;IAC3C,iCAAiC;IACjC,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,qCAAqC;IACrC,UAAU;IACV,uCAAuC;IACvC,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,QAAQ;AACZ;;IAEI;QACI,UAAU;QACV,iCAAiC;QACjC,mBAAmB;QACnB,mBAAmB;IACvB;;AAEJ,WAAW;AACX;IACI,aAAa;IACb,8CAA8C;IAC9C,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,oDAAoD;IACpD,qDAAqD;AACzD;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,gCAAgC;IAChC,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,kBAAkB;IAClB,aAAa;AACjB;;IAEI;QACI,0CAA0C;IAC9C;;AAEJ,uBAAuB;AACvB;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,yBAAyB;AAC7B;;IAEI;QACI,UAAU;IACd;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,oCAAoC;QACpC,mBAAmB;IACvB;;AAEJ,oBAAoB;AACpB;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,wCAAwC;AAC5C;;IAEI;QACI,sBAAsB;QACtB,2CAA2C;QAC3C,8BAA8B;QAC9B,gCAAgC;IACpC;;IAEA;QACI,oBAAoB;QACpB,8CAA8C;QAC9C,+BAA+B;QAC/B,gCAAgC;IACpC;;AAEJ;IACI,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,2CAA2C;IAC3C,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,sBAAsB;IACtB,wCAAwC;AAC5C;;AAEA;IACI,UAAU;IACV,WAAW;IACX,8CAA8C;IAC9C,kBAAkB;IAClB,iBAAiB;IACjB,+CAA+C;IAC/C,YAAY;AAChB;;IAEI;QACI,mBAAmB;IACvB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,qBAAqB;QACrB,eAAe;IACnB;;AAEJ;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,2BAA2B;IAC/B;AACJ;;AAEA,eAAe;AACf;IACI,aAAa;IACb,kBAAkB;IAClB,0BAA0B;IAC1B,yCAAyC;IACzC,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,gCAAgC;IAChC,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,qCAAqC;;IAErC,oCAAoC;IACpC,qBAAqB;IACrB,wBAAwB;IACxB,uCAAuC;AAC3C;;AAEA,4BAA4B;AAC5B;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;;;;;;;;;;;;;;;;;;CAkBC;IACG;QACI,0CAA0C;QAC1C,6CAA6C;IACjD;;AAEJ;IACI,8CAA8C;IAC9C,YAAY;IACZ,gCAAgC;IAChC,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,wCAAwC;AAC5C;;IAEI;QACI,6CAA6C;QAC7C,2BAA2B;QAC3B,yCAAyC;IAC7C;;IAEA;QACI,wBAAwB;QACxB,wCAAwC;IAC5C;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,eAAe;QACf,gBAAgB;IACpB;;AAEJ,oBAAoB;AACpB;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,kBAAkB;AACtB;;AAEA,sBAAsB;AACtB;IACI;QACI,yBAAyB;QACzB,2BAA2B;QAC3B,YAAY;QACZ,QAAQ;IACZ;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;QAEI;YACI,WAAW;YACX,YAAY;QAChB;AACR;;AAEA,+BAA+B;AAC/B;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,SAAS;;AAET;IACI,iBAAiB;IACjB,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,4CAA4C;IAC5C,qBAAqB;IACrB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,iDAAiD;IACjD,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,sBAAsB;AAC1B;;;AAGA,qBAAqB;AACrB,sCAAsC;AACtC;IACI;;;;;kCAK8B;KAC7B,aAAa;IACd,eAAe,EAAE,2CAA2C;IAC5D,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;IAC3B,WAAW,EAAE,sBAAsB;AACvC;;AAEA;IACI;;;;;;;;;;;;;;6BAcyB;;KAExB,oBAAoB;IACrB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,eAAe,EAAE,2BAA2B;IAC5C,wBAAwB;IACxB,YAAY;IACZ,sBAAsB;IACtB,cAAc,EAAE,qCAAqC;IACrD,mBAAmB,EAAE,0BAA0B;IAC/C,eAAe,EAAE,qBAAqB;AAC1C;;AAEA,iCAAiC;AACjC;IACI,8CAA8C;IAC9C,YAAY;IACZ,6CAA6C;AACjD;;AAEA;IACI,6CAA6C;IAC7C,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA,mCAAmC;AACnC;IACI,yBAAyB;IACzB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA,kCAAkC;AAClC;IACI,wBAAwB;IACxB,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,sBAAsB;IACtB,gBAAgB;IAChB,sBAAsB;IACtB,WAAW;AACf;;AAEA,sBAAsB;AACtB;IACI,WAAW;IACX,iBAAiB;IACjB,2BAA2B;IAC3B,YAAY;IACZ,kBAAkB;IAClB,4BAA4B;IAC5B,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA,yBAAyB;AACzB;IACI,iBAAiB;IACjB,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;AACpB;;;AAGA;;IAEI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;;;;AAKA,gDAAgD;CAC/C;IACG,gCAAgC;IAChC,qBAAqB;IACrB,8BAA8B;IAC9B,8BAA8B;IAC9B,qDAAqD;IACrD,yBAAyB;;IAEzB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,4BAA4B;IAC5B,kBAAkB;IAClB,mEAAmE;IACnE,8CAA8C;IAC9C,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,MAAM;IACN,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;;IAGI,WAAW;IACX,2BAA2B;IAC3B,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,8EAA8E;IAC9E,cAAc;IACd,iDAAiD;IACjD,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;;;IAGI,qBAAqB;IACrB,yBAAyB;IACzB,6CAA6C;IAC7C,2BAA2B;AAC/B;;AAEA;;;IAGI,qBAAqB;IACrB,yCAAyC;AAC7C;;;AAGA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,eAAe;IACf,cAAc;IACd,oBAAoB;IACpB,iDAAiD;IACjD,0BAA0B;IAC1B,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;;;;;;IAMI,wCAAwC;IACxC,8CAA8C;IAC9C,cAAc;IACd,gBAAgB;AACpB;;;AAGA;IACI,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,8EAA8E;IAC9E,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,0BAA0B;IAC1B,mBAAmB;IACnB,eAAe;IACf,iDAAiD;IACjD,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;IACX,YAAY;IACZ,qFAAqF;IACrF,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;;AAGA;IACI,aAAa;IACb,SAAS;IACT,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,6BAA6B;AACjC;;;AAGA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iDAAiD;IACjD,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,8EAA8E;AAClF;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,6CAA6C;AACjD;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;AAC7B;;;AAGA;IACI,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,8BAA8B;IAC9B,kBAAkB;IAClB,6BAA6B;IAC7B,kCAAkC;AACtC;;;AAGA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,0CAA0C;IAC1C,gCAAgC;IAChC,6CAA6C;IAC7C,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;;AAGA,eAAe;AACf;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA,oBAAoB;AACpB;;;IAGI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;;;IAGI,4CAA4C;AAChD;;AAEA;;;IAGI,cAAc;AAClB;;AAEA,kBAAkB;AAClB;;;IAGI,qBAAqB;AACzB;;AAEA;;;IAGI,cAAc;AAClB;;;AAGA,gDAAgD;AAChD;IACI,kCAAkC;IAClC,0BAA0B;IAC1B,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,6DAA6D;IAC7D,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iDAAiD;IACjD,gBAAgB;IAChB,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;IAChB,8EAA8E;AAClF;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;IACX,YAAY;IACZ,qFAAqF;IACrF,qBAAqB;AACzB;;AAEA;IACI,6DAA6D;IAC7D,qBAAqB;IACrB,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,kBAAkB;QAClB,eAAe;QACf,gBAAgB;QAChB,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,0DAA0D;QAC1D,kBAAkB;QAClB,cAAc;QACd,wCAAwC;IAC5C;;IAEA;QACI,0DAA0D;QAC1D,qBAAqB;QACrB,+CAA+C;IACnD;;IAEA;QACI,sFAAsF;IAC1F;AACJ;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,OAAO;IACP,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,eAAe;IACf,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,qBAAqB;AACzB;AACA,kBAAkB;AAClB;KACK,8CAA8C;KAC9C,YAAY;KACZ,gCAAgC;KAChC,eAAe;KACf,WAAW;KACX,YAAY;KACZ,kBAAkB;KAClB,2BAA2B;KAC3B,aAAa;KACb,mBAAmB;KACnB,uBAAuB;KACvB,qCAAqC;KACrC,wCAAwC;CAC5C;;KAEI;SACI,6CAA6C;SAC7C,2BAA2B;SAC3B,yCAAyC;KAC7C;;KAEA;SACI,wBAAwB;SACxB,wCAAwC;KAC5C;;KAEA;SACI,WAAW;SACX,YAAY;KAChB;;CAEJ;KACI,oCAAoC;KACpC,uBAAuB;CAC3B;CACA;KACI,oCAAoC;KACpC,sBAAsB;CAC1B;;;;CAIA,qCAAqC;CACrC;IACG,kBAAkB;IAClB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,WAAW;IACX,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;IACrB,4BAA4B;AAChC;;AAEA,sCAAsC,qBAAqB,EAAE;AAC7D,sCAAsC,qBAAqB,EAAE;;AAE7D;IACI,gBAAgB,UAAU,EAAE;IAC5B,MAAM,UAAU,EAAE;AACtB","sourcesContent":["/* Base Variables */\n:root {\n    --chatbot-primary-color: #5c6bc0;\n    --chatbot-primary-light: #8e99f3;\n    --chatbot-primary-dark: #26418f;\n    --chatbot-text-color: #333333;\n    --chatbot-text-light: #ffffff;\n    --chatbot-bg-color: #ffffff;\n    --chatbot-bot-msg-bg: #f0f2ff;\n    --chatbot-user-msg-bg: #e3f2fd;\n    --chatbot-border-radius: 12px;\n    --chatbot-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);\n    --chatbot-transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n    --chatbot-font: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n}\n\n/* Reset */\n.chatbot-widget *,\n.chatbot-widget *::before,\n.chatbot-widget *::after {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n}\n\n/* Main Container */\n.chatbot-widget {\n    position: fixed;\n    bottom: 20px;\n    z-index: 9999;\n    font-family: var(--chatbot-font);\n    color: var(--chatbot-text-color);\n    line-height: 1.5;\n    font-size: 14px;\n}\n\n.chatbot-right {\n  right: 20px;\n}\n\n.chatbot-left {\n  left: 20px;\n}\n\n/* Toggle Button */\n.chatbot-toggle-btn {\n    width: 60px;\n    height: 60px;\n    border-radius: 50%;\n    background-color: var(--chatbot-primary-color);\n    color: var(--chatbot-text-light);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    box-shadow: var(--chatbot-shadow);\n    transition: var(--chatbot-transition);\n    border: none;\n    outline: none;\n    position: relative;\n    z-index: 1;\n}\n\n    .chatbot-toggle-btn:hover {\n        background-color: var(--chatbot-primary-dark);\n        transform: scale(1.05);\n    }\n\n    .chatbot-toggle-btn:active {\n        transform: scale(0.95);\n    }\n\n    .chatbot-toggle-btn svg {\n        width: 24px;\n        height: 24px;\n        transition: var(--chatbot-transition);\n    }\n\n/* Chat Window */\n.chatbot-window {\n    position: absolute;\n    bottom: 80px;\n    \n    /* width: 350px;\n    height: 500px; */\n    width: 25rem;\n    height: 35rem;\n    background-color: var(--chatbot-bg-color);\n    border-radius: var(--chatbot-border-radius);\n    box-shadow: var(--chatbot-shadow);\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    transition: var(--chatbot-transition);\n    opacity: 0;\n    transform: translateY(20px) scale(0.95);\n    pointer-events: none;\n    visibility: hidden;\n}\n\n.chatbot-window-left {\n    left: 0;\n}\n\n.chatbot-window-right {\n    right: 0;\n}\n\n    .chatbot-window.active {\n        opacity: 1;\n        transform: translateY(0) scale(1);\n        pointer-events: all;\n        visibility: visible;\n    }\n\n/* Header */\n.chatbot-header {\n    padding: 16px;\n    background-color: var(--chatbot-primary-color);\n    color: var(--chatbot-text-light);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-top-left-radius: var(--chatbot-border-radius);\n    border-top-right-radius: var(--chatbot-border-radius);\n}\n\n.chatbot-title {\n    font-weight: 600;\n    font-size: 16px;\n    text-align: center;\n    flex-grow: 1;\n}\n\n.chatbot-options-btn {\n    background: transparent;\n    border: none;\n    color: var(--chatbot-text-light);\n    cursor: pointer;\n    padding: 5px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: var(--chatbot-transition);\n    border-radius: 50%;\n    display: none;\n}\n\n    .chatbot-options-btn:hover {\n        background-color: rgba(255, 255, 255, 0.1);\n    }\n\n/* Messages Container */\n.chatbot-messages {\n    flex-grow: 1;\n    padding: 16px;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    scroll-behavior: smooth;\n    background-color: #f9fafc;\n}\n\n    .chatbot-messages::-webkit-scrollbar {\n        width: 6px;\n    }\n\n    .chatbot-messages::-webkit-scrollbar-track {\n        background: transparent;\n    }\n\n    .chatbot-messages::-webkit-scrollbar-thumb {\n        background-color: rgba(0, 0, 0, 0.1);\n        border-radius: 10px;\n    }\n\n/* Message Bubbles */\n.chatbot-message {\n    max-width: 80%;\n    padding: 12px 16px;\n    border-radius: 18px;\n    word-wrap: break-word;\n    position: relative;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n    .chatbot-message.bot {\n        align-self: flex-start;\n        background-color: var(--chatbot-bot-msg-bg);\n        border-bottom-left-radius: 4px;\n        color: var(--chatbot-text-color);\n    }\n\n    .chatbot-message.user {\n        align-self: flex-end;\n        background-color: var(--chatbot-primary-color);\n        border-bottom-right-radius: 4px;\n        color: var(--chatbot-text-light);\n    }\n\n.chatbot-message-time {\n    font-size: 10px;\n    opacity: 0.7;\n    margin-top: 4px;\n    text-align: right;\n}\n\n/* Typing Indicator */\n.chatbot-typing {\n    display: flex;\n    align-items: center;\n    padding: 12px 16px;\n    background-color: var(--chatbot-bot-msg-bg);\n    border-radius: 18px;\n    border-bottom-left-radius: 4px;\n    max-width: 80px;\n    align-self: flex-start;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.chatbot-typing-dot {\n    width: 8px;\n    height: 8px;\n    background-color: var(--chatbot-primary-color);\n    border-radius: 50%;\n    margin-right: 4px;\n    animation: typing-dot 1.4s infinite ease-in-out;\n    opacity: 0.7;\n}\n\n    .chatbot-typing-dot:nth-child(1) {\n        animation-delay: 0s;\n    }\n\n    .chatbot-typing-dot:nth-child(2) {\n        animation-delay: 0.2s;\n    }\n\n    .chatbot-typing-dot:nth-child(3) {\n        animation-delay: 0.4s;\n        margin-right: 0;\n    }\n\n@keyframes typing-dot {\n    0%, 60%, 100% {\n        transform: translateY(0);\n    }\n\n    30% {\n        transform: translateY(-5px);\n    }\n}\n\n/* Input Area */\n.chatbot-input-container {\n    display: flex;\n    padding: 12px 16px;\n    border-top: 1px solid #eee;\n    background-color: var(--chatbot-bg-color);\n    align-items: center;\n}\n\n.chatbot-input {\n    flex-grow: 1;\n    border: 1px solid #ddd;\n    border-radius: 24px;\n    padding: 10px 16px;\n    outline: none;\n    font-family: var(--chatbot-font);\n    font-size: 14px;\n    resize: none;\n    max-height: 100px;\n    min-height: 40px;\n    overflow-y: auto;\n    transition: var(--chatbot-transition);\n    \n    /* Custom webkit scrollbar styling */\n    scrollbar-width: none;\n    -ms-overflow-style: none; \n    /* scrollbar-color: #ccc transparent; */\n}\n\n/* Webkit scrollbar styles */\n.chatbot-input::-webkit-scrollbar {\n    /* width: 6px; */\n    display: none;\n}\n\n/* .chatbot-input::-webkit-scrollbar-track {\n    background: transparent;\n    border-radius: 3px;\n}\n\n.chatbot-input::-webkit-scrollbar-thumb {\n    background-color: #ccc;\n    border-radius: 3px;\n    transition: background-color 0.2s ease;\n}\n\n.chatbot-input::-webkit-scrollbar-thumb:hover {\n    background-color: #999;\n}\n\n.chatbot-input::-webkit-scrollbar-corner {\n    background: transparent;\n}\n*/\n    .chatbot-input:focus {\n        border-color: var(--chatbot-primary-color);\n        box-shadow: 0 0 0 2px rgba(92, 107, 192, 0.2);\n    }\n\n.chatbot-send-btn {\n    background-color: var(--chatbot-primary-color);\n    border: none;\n    color: var(--chatbot-text-light);\n    cursor: pointer;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    margin-left: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: var(--chatbot-transition);\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n}\n\n    .chatbot-send-btn:hover {\n        background-color: var(--chatbot-primary-dark);\n        transform: translateY(-2px);\n        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n    }\n\n    .chatbot-send-btn:active {\n        transform: translateY(0);\n        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n    }\n\n    .chatbot-send-btn svg {\n        width: 18px;\n        height: 18px;\n    }\n\n    .chatbot-send-btn:disabled {\n        background-color: #ccc;\n        cursor: not-allowed;\n        transform: none;\n        box-shadow: none;\n    }\n\n/* Welcome Message */\n.chatbot-welcome {\n    text-align: center;\n    padding: 16px;\n    color: #666;\n    font-style: italic;\n}\n\n/* Responsive Design */\n@media (max-width: 480px) {\n    .chatbot-window {\n        width: calc(100vw - 40px);\n        height: calc(100vh - 120px);\n        bottom: 80px;\n        right: 0;\n    }\n\n    .chatbot-toggle-btn {\n        width: 50px;\n        height: 50px;\n    }\n\n        .chatbot-toggle-btn svg {\n            width: 20px;\n            height: 20px;\n        }\n}\n\n/* Animation for new messages */\n@keyframes message-appear {\n    from {\n        opacity: 0;\n        transform: translateY(10px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.chatbot-message {\n    animation: message-appear 0.3s ease-out;\n}\n\n.chatbot-message-content-user p {\n    color: #fff !important;\n}\n\n/*footer*/\n\n.chatbot-footer {\n    padding: 8px 16px;\n    background-color: #f8f9fa;\n    border-top: 1px solid #e9ecef;\n    text-align: center;\n    font-size: 11px;\n    color: #6c757d;\n    border-bottom-left-radius: 12px;\n    border-bottom-right-radius: 12px;\n}\n\n.chatbot-powered-by {\n    color: #6c757d;\n}\n\n.chatbot-powered-link {\n    color: var(--chatbot-primary-color, #5c6bc0);\n    text-decoration: none;\n    font-weight: 500;\n    transition: color 0.2s ease;\n}\n\n.chatbot-powered-link:hover {\n    color: var(--chatbot-primary-color-dark, #3f51b5);\n    text-decoration: underline;\n}\n\n.chatbot-powered-logo {\n    height: 15px;\n    width: auto;\n    vertical-align: middle;\n}\n\n\n/* For Support desk */\n/* Base Button Style with Transition */\n.chatbot-buttons {\n    /* display: flex;\n     flex-wrap: wrap;\n    gap: 8px;\n    margin-top: 12px;\n    margin-left: 5px;\n    justify-content: flex-start; */\n     display: flex;\n    flex-wrap: wrap; /* Allow buttons to wrap on small screens */\n    gap: 8px;\n    margin-top: 12px;\n    margin-left: 5px;\n    justify-content: flex-start;\n    width: 100%; /* Ensure full width */\n}\n\n.chatbot-button {\n    /* display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    \n    border-radius: 16px;\n    font-size: 13px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease-out;\n    border: none;\n    outline: none;\n    \n      min-width: calc(50% - 10px);\n    height: 35px;\n    box-sizing: border-box; */\n\n     display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 16px;\n    font-size: 13px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease-out;\n    border: none;\n    outline: none;\n    min-width: auto; /* Remove fixed min-width */\n    /* padding: 6px 16px;  */\n    height: 35px;\n    box-sizing: border-box;\n    flex: 1 1 auto; /* Allow buttons to grow and shrink */\n    white-space: nowrap; /* Prevent text wrapping */\n    max-width: 100%; /* Prevent overflow */\n}\n\n/* Primary Button Hover Effects */\n.chatbot-button--primary {\n    background-color: var(--chatbot-primary-color);\n    color: white;\n    box-shadow: 0 1px 2px rgba(74, 107, 255, 0.2);\n}\n\n.chatbot-button--primary:hover {\n    background-color: var(--chatbot-primary-dark);\n    transform: translateY(-1px);\n    box-shadow: 0 2px 4px rgba(74, 107, 255, 0.3);\n}\n\n/* Secondary Button Hover Effects */\n.chatbot-button--secondary {\n    background-color: #f5f5f5;\n    color: #333;\n    border: 1px solid #ddd;\n}\n\n.chatbot-button--secondary:hover {\n    background-color: #e9e9e9;\n    border-color: #ccc;\n    transform: translateY(-1px);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n/* Active State for Both Buttons */\n.chatbot-button:active {\n    transform: translateY(0);\n    transition: all 0.1s ease;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n/* Options container */\n.chatbot-options-container {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    /* Reduced from 10px */\n    margin-top: 10px;\n    /* Reduced from 12px */\n    width: 100%;\n}\n\n/* Base button style */\n.chatbot-option-button {\n    width: 100%;\n    padding: 8px 12px;\n    /* Reduced from 12px 16px */\n    border: none;\n    border-radius: 6px;\n    /* Slightly smaller radius */\n    background-color: #f0f4f8;\n    color: #2d3748;\n    font-size: 13px;\n    /* Reduced from 14px */\n    font-weight: 500;\n    text-align: center;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n/* Small button variant */\n.chatbot-option-button-small {\n    padding: 6px 10px;\n    /* Even smaller padding */\n    font-size: 12px;\n    /* Smaller font */\n    min-height: 32px;\n    /* Fixed height */\n}\n\n.chatbot-option-button:hover {\n    background-color: #e2e8f0;\n    transform: translateY(-1px);\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    /* Lighter shadow */\n}\n\n.chatbot-option-button:active {\n    transform: translateY(0);\n    box-shadow: none;\n}\n\n\n.chatbot-option-button:disabled,\n.chatbot-option-button.disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.chatbot-attach-btn {\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    padding: 4px;\n    color: #666;\n    position: absolute;\n    left: 26px;\n}\n\n.chatbot-attach-btn:hover {\n    color: #000;\n}\n\n\n\n\n/* Support Form Styles - Clean Material Design */\n .support-form-container {\n    /* max-width: 100% !important; */\n    padding: 0 !important;\n    background: #ffffff !important;\n    border-radius: 16px !important;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08) !important;\n    margin: 16px 0 !important;\n  \n    border: 1px solid #f0f0f0;\n} \n\n.support-form-header {\n    font-size: 15px;\n    font-weight: 600;\n    color: #1a1a1a;\n    margin: 0;\n    padding: 12px 12px 12px 12px;\n    text-align: center;\n    /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */\n    background-color: var(--chatbot-primary-color);\n    color: white;\n    position: relative;\n}\n\n.support-form-header::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 1px;\n    background: rgba(255, 255, 255, 0.2);\n}\n\n.support-form {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n    padding: 24px;\n}\n\n.form-field {\n    position: relative;\n    margin-bottom: 10px;\n}\n\n.form-input-chatbot,\n.form-select-chatbot,\n.form-textarea-chatbot {\n    width: 100%;\n    padding: 5px 10px 10px 10px;\n    border: 2px solid #e8eaed;\n    border-radius: 12px;\n    background-color: #ffffff;\n    font-size: 16px;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n    color: #202124;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    outline: none;\n    box-sizing: border-box;\n    appearance: none;\n}\n\n.form-input-chatbot:focus,\n.form-select-chatbot:focus,\n.form-textarea-chatbot:focus {\n    border-color: #4285f4;\n    background-color: #ffffff;\n    box-shadow: 0 0 0 4px rgba(66, 133, 244, 0.1);\n    transform: translateY(-1px);\n}\n\n.form-input-chatbot:hover:not(:focus),\n.form-select-chatbot:hover:not(:focus),\n.form-textarea-chatbot:hover:not(:focus) {\n    border-color: #dadce0;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n} \n\n\n.form-label {\n    position: absolute;\n    left: 16px;\n    top: 12px;\n    font-size: 13px;\n    color: #5f6368;\n    pointer-events: none;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    transform-origin: left top;\n    background: white;\n    padding: 0 4px;\n    margin-left: -4px;\n    font-weight: 400;\n}\n\n.form-input-chatbot:focus + .form-label,\n.form-input-chatbot:not(:placeholder-shown) + .form-label,\n.form-select-chatbot:focus + .form-label,\n.form-select-chatbot:valid + .form-label,\n.form-textarea-chatbot:focus + .form-label,\n.form-textarea-chatbot:not(:placeholder-shown) + .form-label {\n    transform: translateY(-22px) scale(0.75);\n    /* transform: translateY(-28px) scale(0.75); */\n    color: #4285f4;\n    font-weight: 500;\n}\n\n\n.form-underline {\n    display: none;\n}\n.form-textarea {\n    resize: vertical;\n    min-height: 120px;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n    line-height: 1.5;\n}\nform-field-file {\n    margin-bottom: 10px;\n}\n\n.form-file-input {\n    display: none;\n}\n\n.form-file-label {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    padding: 7px;\n    border: 2px dashed #dadce0;\n    border-radius: 12px;\n    cursor: pointer;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    background-color: #fafbfc;\n    position: relative;\n    overflow: hidden;\n}\n\n.form-file-label::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(90deg, transparent, rgba(66, 133, 244, 0.1), transparent);\n    transition: left 0.5s;\n}\n\n.form-file-label:hover {\n    border-color: #4285f4;\n    background-color: #f8f9ff;\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(66, 133, 244, 0.15);\n}\n\n.form-file-label:hover::before {\n    left: 100%;\n}\n\n.file-icon {\n    font-size: 18px;\n    color: #4285f4;\n}\n\n.file-text {\n    color: #5f6368;\n    font-size: 14px;\n    font-weight: 500;\n}\n\n\n.form-actions {\n    display: flex;\n    gap: 12px;\n    justify-content: flex-end;\n    margin-top: 0px;\n    padding-top: 24px;\n    border-top: 1px solid #f0f0f0;\n} \n\n\n.btn-chatbot {\n    position: relative;\n    padding: 10px 32px;\n    border: none;\n    border-radius: 24px;\n    font-size: 15px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    overflow: hidden;\n    text-transform: none;\n    letter-spacing: 0.25px;\n    min-width: 100px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n.btn-chatbot-primary {\n    background: linear-gradient(135deg, #4285f4 0%, #34a853 100%);\n    color: white;\n    box-shadow: 0 2px 8px rgba(66, 133, 244, 0.3);\n}\n\n.btn-chatbot-primary:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(66, 133, 244, 0.4);\n}\n\n.btn-chatbot-primary:active {\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(66, 133, 244, 0.3);\n}\n\n.btn-chatbot-secondary {\n    background-color: #ffffff;\n    color: #5f6368;\n    border: 2px solid #e8eaed;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.btn-chatbot-secondary:hover {\n    background-color: #f8f9fa;\n    border-color: #dadce0;\n    transform: translateY(-1px);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.btn-chatbot-secondary:active {\n    transform: translateY(0);\n    background-color: #f1f3f4;\n}\n\n\n.btn-chatbot.loading {\n    pointer-events: none;\n    opacity: 0.8;\n}\n\n.btn-chatbot.loading .btn-chatbot-text::after {\n    content: '';\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n    margin-left: 8px;\n    border: 2px solid currentColor;\n    border-radius: 50%;\n    border-top-color: transparent;\n    animation: spin 1s linear infinite;\n}\n\n\n.btn-chatbot-ripple {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 0;\n    height: 0;\n    border-radius: 50%;\n    background-color: rgba(255, 255, 255, 0.4);\n    transform: translate(-50%, -50%);\n    transition: width 0.6s ease, height 0.6s ease;\n    pointer-events: none;\n}\n\n.btn-chatbot:active .btn-chatbot-ripple {\n    width: 300px;\n    height: 300px;\n} \n\n\n/* Animations */\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n/* Form Validation */\n.form-input-chatbot:invalid:not(:placeholder-shown),\n.form-select-chatbot:invalid,\n.form-textarea-chatbot:invalid:not(:placeholder-shown) {\n    border-color: #ea4335;\n    background-color: #fef7f0;\n}\n\n.form-input-chatbot:invalid:not(:placeholder-shown):focus,\n.form-select-chatbot:invalid:focus,\n.form-textarea-chatbot:invalid:not(:placeholder-shown):focus {\n    box-shadow: 0 0 0 4px rgba(234, 67, 53, 0.1);\n}\n\n.form-input-chatbot:invalid:not(:placeholder-shown)+.form-label,\n.form-select:invalid+.form-label,\n.form-textarea-chatbot:invalid:not(:placeholder-shown)+.form-label {\n    color: #ea4335;\n}\n\n/* Success State */\n.form-input-chatbot:valid:not(:placeholder-shown),\n.form-select-chatbot:valid:not([value=\"\"]),\n.form-textarea-chatbot:valid:not(:placeholder-shown) {\n    border-color: #34a853;\n}\n\n.form-input-chatbot:valid:not(:placeholder-shown)+.form-label,\n.form-select-chatbot:valid:not([value=\"\"])+.form-label,\n.form-textarea-chatbot:valid:not(:placeholder-shown)+.form-label {\n    color: #34a853;\n}\n\n\n/* Enhanced Quick Actions with Material Design */\n.quick-actions-container {\n    background: transparent !important;\n    padding: 12px 0 !important;\n    margin: 8px 0 !important;\n}\n\n.quick-actions {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    max-width: 320px;\n}\n\n.quick-action-btn {\n    padding: 16px 20px;\n    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);\n    border: 2px solid #e8eaed;\n    border-radius: 16px;\n    color: #1a73e8;\n    font-size: 15px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    text-align: left;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n    position: relative;\n    overflow: hidden;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n.quick-action-btn::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(90deg, transparent, rgba(26, 115, 232, 0.1), transparent);\n    transition: left 0.5s;\n}\n\n.quick-action-btn:hover {\n    background: linear-gradient(135deg, #f8f9ff 0%, #e8f0fe 100%);\n    border-color: #4285f4;\n    transform: translateY(-2px);\n    box-shadow: 0 4px 16px rgba(66, 133, 244, 0.2);\n}\n\n.quick-action-btn:hover::before {\n    left: 100%;\n}\n\n.quick-action-btn:active {\n    transform: translateY(-1px);\n    box-shadow: 0 2px 8px rgba(66, 133, 244, 0.15);\n}\n\n.quick-action-btn:focus {\n    outline: none;\n    border-color: #4285f4;\n    box-shadow: 0 0 0 4px rgba(66, 133, 244, 0.1);\n}\n\n@media (max-width: 480px) {\n    .quick-actions {\n        max-width: 100%;\n    }\n\n    .quick-action-btn {\n        text-align: center;\n        padding: 18px 20px;\n        font-size: 16px;\n        min-height: 48px;\n        touch-action: manipulation;\n    }\n}\n\n@media (prefers-color-scheme: dark) {\n    .quick-action-btn {\n        background: linear-gradient(135deg, #2d2d2d 0%, #333 100%);\n        border-color: #444;\n        color: #8ab4f8;\n        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n    }\n\n    .quick-action-btn:hover {\n        background: linear-gradient(135deg, #333 0%, #3c3c3c 100%);\n        border-color: #8ab4f8;\n        box-shadow: 0 4px 16px rgba(138, 180, 248, 0.2);\n    }\n\n    .quick-action-btn::before {\n        background: linear-gradient(90deg, transparent, rgba(138, 180, 248, 0.1), transparent);\n    }\n}\n\n.file-list {\n    margin-top: 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.file-item {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 12px 16px;\n    background-color: #f8f9fa;\n    border-radius: 8px;\n    border: 1px solid #e8eaed;\n    transition: all 0.2s ease;\n}\n\n.file-item:hover {\n    background-color: #f1f3f4;\n    border-color: #dadce0;\n}\n\n.file-name {\n    flex: 1;\n    color: #202124;\n    font-weight: 500;\n    margin-right: 12px;\n    font-size: 14px;\n    overflow-x: auto;\n}\n\n.file-size {\n    color: #5f6368;\n    font-size: 12px;\n    margin-right: 12px;\n    background: #e8f0fe;\n    padding: 2px 8px;\n    border-radius: 12px;\n}\n\n.file-remove {\n    background: #fff;\n    border: 1px solid #dadce0;\n    color: #ea4335;\n    font-size: 16px;\n    cursor: pointer;\n    padding: 0;\n    width: 28px;\n    height: 28px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    transition: all 0.2s ease;\n    font-weight: bold;\n}\n\n.file-remove:hover {\n    background-color: #fce8e6;\n    border-color: #ea4335;\n    transform: scale(1.1);\n} \n/* for live chat */\n.chatlive-send-btn {\n     background-color: var(--chatbot-primary-color);\n     border: none;\n     color: var(--chatbot-text-light);\n     cursor: pointer;\n     width: 40px;\n     height: 40px;\n     border-radius: 50%;\n     margin-left: 8px !important;\n     display: none;\n     align-items: center;\n     justify-content: center;\n     transition: var(--chatbot-transition);\n     box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n }\n \n     .chatlive-send-btn:hover {\n         background-color: var(--chatbot-primary-dark);\n         transform: translateY(-2px);\n         box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n     }\n \n     .chatlive-send-btn:active {\n         transform: translateY(0);\n         box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n     }\n \n     .chatlive-send-btn svg {\n         width: 18px;\n         height: 18px;\n     }\n \n .active-op {\n     background-color: #4a90e2 !important;\n     color: white !important;\n }\n .inactive-op {\n     background-color: #f5f5f5 !important;\n     color: #333 !important;\n }\n\n\n\n /* For Type indecater dor live chat */\n .typing-indicator {\n    font-style: italic;\n    margin: 5px 0;\n    color: #555;\n}\n\n.typing-indicator .dot {\n    height: 6px;\n    width: 6px;\n    margin: 0 2px;\n    background-color: #555;\n    border-radius: 50%;\n    display: inline-block;\n    animation: blink 1s infinite;\n}\n\n.typing-indicator .dot:nth-child(2) { animation-delay: 0.2s; }\n.typing-indicator .dot:nth-child(3) { animation-delay: 0.4s; }\n\n@keyframes blink {\n    0%, 80%, 100% { opacity: 0; }\n    40% { opacity: 1; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
